import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import { SaveOutlined } from '@ant-design/icons';

import { Formik, Form, Field } from 'formik';
import { Card, Row, Col, Typography, Space } from 'antd';
import { FormikSelect, FormikButton, FormikInput } from '../../Components/Formik';
import CountAdjSync02Actions from '../../Stores/CountAdjSync02/Actions';

const { Text } = Typography;

class CountAdjSync02SyncSetting extends React.PureComponent {
  constructor() {
    super();

    this.handleCompanySearch = this.handleCompanySearch.bind(this);
    this.handleLocationSearch = this.handleLocationSearch.bind(this);
    this.handleSearchItemGroup01 = this.handleSearchItemGroup01.bind(this);
    this.handleItemSearch = this.handleItemSearch.bind(this);
  }

  componentDidMount() {
    const { fetchSettings } = this.props;
    fetchSettings();
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  handleCompanySearch(form, value) {
    const { fetchCompanyOptions } = this.props;

    fetchCompanyOptions(value);
  }

  handleLocationSearch(form, value) {
    const { fetchLocationOptions } = this.props;

    fetchLocationOptions(value);
  }

  handleSearchItemGroup01(form, value) {
    const { fetchItemGroup01Options } = this.props;

    fetchItemGroup01Options(value);
  }

  handleItemSearch(form, value) {
    const { fetchItemOptions } = this.props;

    fetchItemOptions(value);
  }

  render() {
    const {
      intl,
      fetchIsLoading,
      exportIsLoading,
      settings,
      saveSettings,
      companyIsLoading,
      companyOptions,
      locationIsLoading,
      locationOptions,
      itemGroup01Options,
      itemGroup01IsLoading,
      itemIsLoading,
      itemOptions
    } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={settings}
        onSubmit={(values, formikBag) => {
          saveSettings(formikBag, values);
        }}
      >
        {({
          // values,
          // handleChange,
          // errors,
          // setFieldTouched,
          // dirty,
          // touched,
          isSubmitting,
          // isValid,
          handleSubmit
          // handleReset
        }) => (
          <Form>
            <Card>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Row type="flex" justify="center" gutter={[8, 8]}>
                  <Col span={3}>
                    <Text>{intl.formatMessage({ id: 'cron' })}</Text>
                  </Col>
                  <Col span={1}>
                    <Text>:</Text>
                  </Col>
                  <Col span={20}>
                    <Field name="cron" component={FormikInput} />
                  </Col>
                </Row>

                <Row type="flex" justify="center" gutter={[8, 8]}>
                  <Col span={3}>
                    <Text>{intl.formatMessage({ id: 'company' })}</Text>
                  </Col>
                  <Col span={1}>
                    <Text>:</Text>
                  </Col>
                  <Col span={20}>
                    <Field
                      name="company_id_select2"
                      component={FormikSelect}
                      showArrow
                      filterOption={false}
                      onSearch={this.handleCompanySearch}
                      notFoundContent={null}
                      loading={companyIsLoading}
                      options={companyOptions}
                      disabled={isSubmitting}
                    />
                  </Col>
                </Row>

                <Row type="flex" justify="center" gutter={[8, 8]}>
                  <Col span={3}>
                    <Text>{intl.formatMessage({ id: 'location' })}</Text>
                  </Col>
                  <Col span={1}>
                    <Text>:</Text>
                  </Col>
                  <Col span={20}>
                    <Field
                      name="location_id_select2"
                      component={FormikSelect}
                      showArrow
                      filterOption={false}
                      onSearch={this.handleLocationSearch}
                      notFoundContent={null}
                      loading={locationIsLoading}
                      options={locationOptions}
                      disabled={isSubmitting}
                    />
                  </Col>
                </Row>

                <Row type="flex" justify="center" gutter={[8, 8]}>
                  <Col span={3}>
                    <Text>{intl.formatMessage({ id: 'brand' })}</Text>
                  </Col>
                  <Col span={1}>
                    <Text>:</Text>
                  </Col>
                  <Col span={20}>
                    <Field
                      name="item_group_01_ids_select2"
                      component={FormikSelect}
                      showArrow
                      filterOption={false}
                      onSearch={this.handleSearchItemGroup01}
                      notFoundContent={null}
                      loading={itemGroup01IsLoading}
                      options={itemGroup01Options}
                      disabled={isSubmitting || fetchIsLoading}
                      selectMode="multiple"
                    />
                  </Col>
                </Row>

                <Row type="flex" justify="center" gutter={[8, 8]}>
                  <Col span={3}>
                    <Text>{intl.formatMessage({ id: 'item' })}</Text>
                  </Col>
                  <Col span={1}>
                    <Text>:</Text>
                  </Col>
                  <Col span={20}>
                    <Field
                      name="item_ids_select2"
                      component={FormikSelect}
                      showArrow
                      filterOption={false}
                      onSearch={this.handleItemSearch}
                      notFoundContent={null}
                      loading={itemIsLoading}
                      options={itemOptions}
                      disabled={isSubmitting}
                      selectMode="multiple"
                    />
                  </Col>
                </Row>

                <Row type="flex" justify="end" gutter={[0, 16]}>
                  <Col>
                    <Field
                      type="primary"
                      name="submit_action"
                      value="save"
                      component={FormikButton}
                      loading={isSubmitting || fetchIsLoading || exportIsLoading}
                      onClick={handleSubmit}
                      label={intl.formatMessage({ id: 'save' })}
                      icon={<SaveOutlined />}
                    />
                  </Col>
                </Row>
              </Space>
            </Card>
          </Form>
        )}
      </Formik>
    );
  }
}

CountAdjSync02SyncSetting.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  settings: PropTypes.shape({}),

  fetchIsLoading: PropTypes.bool,
  exportIsLoading: PropTypes.bool,

  fetchSettings: PropTypes.func,
  saveSettings: PropTypes.func,

  fetchCompanyOptions: PropTypes.func,
  companyIsLoading: PropTypes.bool,
  companyOptions: PropTypes.arrayOf(PropTypes.object),

  fetchLocationOptions: PropTypes.func,
  locationIsLoading: PropTypes.bool,
  locationOptions: PropTypes.arrayOf(PropTypes.object),

  fetchItemGroup01Options: PropTypes.func,
  itemGroup01Options: PropTypes.arrayOf(PropTypes.object),
  itemGroup01IsLoading: PropTypes.bool,

  fetchItemOptions: PropTypes.func,
  itemIsLoading: PropTypes.bool,
  itemOptions: PropTypes.arrayOf(PropTypes.object)
};

CountAdjSync02SyncSetting.defaultProps = {
  intl: {},

  settings: {
    cron: '',
    company_id_select2: { value: 0, label: '' },
    location_id_select2: { value: 0, label: '' },
    item_group_01_ids_select2: [],
    item_ids_select2: []
  },

  fetchIsLoading: false,
  exportIsLoading: false,

  fetchSettings() {},
  saveSettings() {},

  fetchCompanyOptions() {},
  companyIsLoading: false,
  companyOptions: [],

  fetchLocationOptions() {},
  locationIsLoading: false,
  locationOptions: [],

  fetchItemGroup01Options() {},
  itemGroup01Options: [],
  itemGroup01IsLoading: false,

  fetchItemOptions() {},
  itemIsLoading: false,
  itemOptions: []
};

const mapStateToProps = state => ({
  settings: state.countAdjSync02.settings,
  fetchIsLoading: state.countAdjSync02.fetchIsLoading,
  exportIsLoading: state.countAdjSync02.exportIsLoading,

  companyIsLoading: state.countAdjSync02.companyIsLoading,
  companyOptions: state.countAdjSync02.companyOptions,

  locationIsLoading: state.countAdjSync02.locationIsLoading,
  locationOptions: state.countAdjSync02.locationOptions,

  itemGroup01Options: state.countAdjSync02.itemGroup01Options,
  itemGroup01IsLoading: state.countAdjSync02.itemGroup01IsLoading,

  itemIsLoading: state.countAdjSync02.itemIsLoading,
  itemOptions: state.countAdjSync02.itemOptions
});

const mapDispatchToProps = dispatch => ({
  fetchSettings: () => dispatch(CountAdjSync02Actions.countAdjSync02ShowSetting()),
  saveSettings: (formikBag, settings) =>
    dispatch(CountAdjSync02Actions.countAdjSync02SaveSetting(formikBag, settings)),

  fetchCompanyOptions: search =>
    dispatch(CountAdjSync02Actions.countAdjSync02FetchCompanyOptions(search)),
  fetchLocationOptions: search =>
    dispatch(CountAdjSync02Actions.countAdjSync02FetchLocationOptions(search)),
  fetchItemGroup01Options: search =>
    dispatch(CountAdjSync02Actions.countAdjSync02FetchItemGroup01Options(search)),
  fetchItemOptions: search => dispatch(CountAdjSync02Actions.countAdjSync02FetchItemOptions(search))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CountAdjSync02SyncSetting));
